const Blobimages = {mainlogo:"https://yeldamimages.azureedge.net/yeldamwebimages/webp/yeldam-logo.webp"}
export default Blobimages